import type { NavGroup } from './admin-nav-group';

function shouldShowByFeatureFlag(
  featureFlag: string | ((flags: Record<string, boolean>) => boolean) | undefined,
  flags: Record<string, boolean>,
): boolean {
  if (!featureFlag) {
    return true;
  }

  if (typeof featureFlag === 'string') {
    return Boolean(flags[featureFlag]);
  }

  // featureFlag is a function
  return featureFlag(flags);
}

export function filterNavGroups(groups: NavGroup[], flags: Record<string, boolean>): NavGroup[] {
  return groups
    .filter((group) => {
      // If group has a feature flag, it must pass the check
      return shouldShowByFeatureFlag(group.featureFlag, flags);
    })
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => {
        // If item has a feature flag, it must pass the check
        return shouldShowByFeatureFlag(item.featureFlag, flags);
      }),
    }))
    .filter((group) => {
      // Remove groups with no items after filtering
      return group.items.length > 0;
    });
}
